import { Easing } from 'react-native-reanimated';

export const PROGRESS_ANIMATION_CONFIG = {
  easing: Easing.out(Easing.cubic),
  startDelay: 200,
  pointsPerSec: 100, // Controls the speed of the animation
} as const;

export const MIN_ANIMATION_DURATION = 400;
export const MAX_ANIMATION_DURATION = 1200;
